import { ACTION_TYPE } from "../core/redux/actionType";
import {
  hasTrippedBreaker,
  updateBreaker,
} from "../core/redux/api/circuitBreaker/module";
import { apiSaveLiftAccessRules } from "../core/redux/api/endpoints";
import {
  addError,
  addLoading,
  removeLoadingAndError,
} from "../core/redux/api/module";
import {
  ApiReducer,
  makeApiAction,
  makeApiReducer,
  RsaaTypes,
} from "../core/redux/api/reduxStandardApiAction";
import { IAppState } from "../core/redux/IAppState";
import { AccessRuleChangeRequest } from "./accessRules/requests/accessRuleRequestBuilder";
import { LiftAccessRuleSaveResult } from "./models";

export const KEY_ACTION = ACTION_TYPE.SAVE_LIFT_ACCESS_RULES_REQUEST;

export const ACTIONS = [
  ACTION_TYPE.SAVE_LIFT_ACCESS_RULES_REQUEST,
  ACTION_TYPE.SAVE_LIFT_ACCESS_RULES_RESPONSE,
  ACTION_TYPE.SAVE_LIFT_ACCESS_RULES_ERROR,
];

/**
 * POST: Save Lift Access Rules for a single entitlement context (entitlement type + fulfillment season + scope)
 */
export const saveLiftAccessRulesAction = (
  saveRequest: AccessRuleChangeRequest,
) => {
  return makeApiAction({
    endpoint: apiSaveLiftAccessRules(),
    method: "POST",
    body: JSON.stringify(saveRequest),

    headers: (state: IAppState) => ({
      "content-type": "application/json",
      Authorization: `Bearer ${state.auth.bearerToken}`,
    }),

    types: ACTIONS.map((type) => ({
      type,
      meta: { saveRequest },
    })) as RsaaTypes,

    bailout: (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION),
  });
};

const reducer: ApiReducer<LiftAccessRuleSaveResult> = (
  state,
  action,
  error,
  isLoading,
  payload,
) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  // TODO (future iteration) - update contract between UI and API and look at the error
  // to provide a better error message to the user.
  if (error) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error);
  }

  return removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);
};

export const saveLiftAccessRulesReducer =
  makeApiReducer<LiftAccessRuleSaveResult>(ACTIONS, KEY_ACTION, reducer);
